import type { Tile } from '../../context/ContentContext/contentTypes';
import { getPreviouslyVisited } from '../getPreviouslyVisited';
import { getModelNameFromUrl } from '../tracker/getModelNameFromUrl';
import { getPageTypeFromUrl } from '../tracker/getPageTypeFromUrl';
import { removeHyphens } from './utils/removeHyphens';

export const getClickEvent = (
  eventAction: string,
  sanitizedUrl: string,
  tile: Tile,
  index: number,
  isPersonalized: boolean,
) => {
  const position = index + 1;
  const modelName = getModelNameFromUrl(sanitizedUrl);

  return {
    eventInfo: {
      eventAction,
      eventName: 'personalized content tiles - click on content tile',
    },
    attributes: {
      type: 'personalizedTiles|Click',
      payload: {
        tiles: [
          {
            modelName: modelName ? removeHyphens(modelName) : null, // clicked tile's model name
            targetPage: getPageTypeFromUrl(sanitizedUrl), // clicked tile's target page type: build / mlp
            position: position.toString(), // clicked tile's postion
            personalized: isPersonalized, // if clicked tile's is personalized
          },
        ],
        previouslyVisted: getPreviouslyVisited(),
        element: {
          clickText: tile.CTA?.text || tile.heading?.text || '',
          section: '', // TODO
          url: sanitizedUrl,
        },
        featureApp: {
          name: 'Personalized Content Tiles', // appStore.title
          id: 'a146211c-ca73-4e7a-9e70-5f22661e53e1', // appStore.appId
          baseUrl: 'https://fa-content-tiles-personalized.cdn.prod.collab.apps.one.audi/', // appStore.extra.featureHub.baseUrl
        },
      },
    },
  };
};
